import { Card, Col, Row } from "antd";
import React, { useState, useEffect } from "react";
import imageAll from "./../images/GrouAll.png";
import imageLetter from "./../images/ImageLetter.png";
import imageOther from "./../images/ImageOther.png";
import imageContact from "./../images/GroupContact.png";
import imageNocantact from "./../images/GroupNoconcect.png";
import { DashboardService } from "./../services/dashboard-service";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";

const appConfig = loadAppConfig();

interface Props {
  baseUrl: string;
  setLoading: (status: boolean) => void;
}

const rowStyle = {
  fontSize: "10px",
  color: "#000000",
  whiteSpace: "pre-wrap",
} as any;

interface SummaryCardProps {
  title: string;
  color: string;
  icon: string;
  ac: number;
  bal: number;
  acPer: number;
  balPer: number;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, color, icon, ac, bal, acPer, balPer }) => (
  <Card className="summary-card" style={{ textAlign: "left", borderRadius: 10 }}>
    <Row gutter={8}>
      <Col span={6}>
        <img src={icon} width="45px" />
      </Col>
      <Col span={18}>
        <b style={{ fontSize: 15, color }}>{title}</b>
        <Row>
          <Col span={12}>
            <div style={rowStyle}>
              A/C <NumberFormat value={ac} displayType="text" thousandSeparator />
            </div>
            <div style={rowStyle}>
              BAL <NumberFormat value={bal} displayType="text" thousandSeparator decimalScale={2} />
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <div style={rowStyle}>
              %A/C <NumberFormat value={acPer} displayType="text" decimalScale={2} />%
            </div>
            <div style={rowStyle}>
              %BAL <NumberFormat value={balPer} displayType="text" decimalScale={2} />%
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Card>
);

interface DetailCardProps {
  title: string;
  color: string;
  onClick: () => void;
  ac: number;
  acPer: number;
  bal: number;
  balPer: number;
}

const DetailCard: React.FC<DetailCardProps> = ({ title, color, onClick, ac, acPer, bal, balPer }) => (
  <Card className="detail-card" style={{ textAlign: "left", borderRadius: 10, marginBottom: 5 }}>
    <a onClick={onClick} style={{ fontSize: 16, color, fontWeight: "bold" }} className="detail-title">
      {title}
    </a>
    <Row>
      <Col span={12} style={rowStyle}>
        A/C <NumberFormat value={ac} displayType="text" thousandSeparator />
      </Col>
      <Col span={12} style={rowStyle}>
        %A/C <NumberFormat value={acPer} displayType="text" decimalScale={2} />%
      </Col>
      <Col span={12} style={rowStyle}>
        BAL <NumberFormat value={bal} displayType="text" decimalScale={2} thousandSeparator />
      </Col>
      <Col span={12} style={rowStyle}>
        %BAL <NumberFormat value={balPer} displayType="text" decimalScale={2} />%
      </Col>
    </Row>
  </Card>
);

export const ActionContact: React.FC<Props> = ({ baseUrl, setLoading }) => {
  const { id24Axios } = useId24();
  const history = useHistory();

  const [dataSourceAll, setDataSourceAll] = useState<any[]>([]);
  const [dataSourceByActionContact, setDataSourceByActionContact] = useState<any[]>([]);
  const [dataSourceByActionNoContact, setDataSourceByActionNoContact] = useState<any[]>([]);
  const [dataSourceByActionLetter, setDataSourceByActionLetter] = useState<any[]>([]);
  const [dataSourceByActionOther, setDataSourceByActionOther] = useState<any[]>([]);

  const [dataSumAll, setDataSumAll] = useState<any[]>([]);
  const [dataSumContact, setDataSumContact] = useState<any[]>([]);
  const [dataSumNoContact, setDataSumNoContact] = useState<any[]>([]);
  const [dataSumLetter, setDataSumLetter] = useState<any[]>([]);
  const [dataSumOther, setDataSumOther] = useState<any[]>([]);

  const buildSummary = (data: any[], totalAmt: number, totalCnt: number, status: string) => {
    const sumCnt = data.reduce((s, v) => s + v.cnt, 0);
    const sumCount = data.reduce((s, v) => s + v.count, 0);
    return [{ status, sumCnt, sumCount, sumCntPer: (sumCount * 100) / totalCnt, sumCountPer: (sumCnt * 100) / totalAmt }];
  };

  const buildDetail = (data: any[], totalAmt: number, totalCnt: number) =>
    data.map((v) => ({
      status_name: v.status_name,
      status_code: v.status_code,
      count: v.count,
      cnt: v.cnt,
      countPer: (v.count * 100) / totalCnt,
      cntPer: (v.cnt * 100) / totalAmt,
    }));

  const buildAllDetail = (data: any[], totalAmt: number, totalCnt: number) =>
    data.map((v) => ({
      actionstatus: v.actionstatus,
      sumamt: v.sumamt,
      cnt: v.cnt,
      sumamtPer: (v.sumamt * 100) / totalAmt,
      cntPer: (v.cnt * 100) / totalCnt,
    }));

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const apiCaller = id24Axios(appConfig.apiBaseUrlDebt);
      const service = DashboardService(apiCaller);

      const [resAll, resContact, resNoContact, resLetter, resOther] = await Promise.all([
        service.getOaCollectorAll(""),
        service.getOaCollectorByAction({ actionCode: "contact" }),
        service.getOaCollectorByAction({ actionCode: "noContact" }),
        service.getOaCollectorByAction({ actionCode: "letter" }),
        service.getOaCollectorByAction({ actionCode: "other" }),
      ]);

      const totalCnt = resAll.result.reduce((s: number, v: any) => s + v.cnt, 0);
      const totalAmt = resAll.result.reduce((s: number, v: any) => s + v.sumamt, 0);

      setDataSumAll([{ status: "all", sumCnt: totalCnt, sumAmt: totalAmt }]);
      setDataSourceAll(buildAllDetail(resAll.result, totalAmt, totalCnt));

      setDataSumContact(buildSummary(resContact.result, totalAmt, totalCnt, "contact"));
      setDataSourceByActionContact(buildDetail(resContact.result, totalAmt, totalCnt));

      setDataSumNoContact(buildSummary(resNoContact.result, totalAmt, totalCnt, "noContact"));
      setDataSourceByActionNoContact(buildDetail(resNoContact.result, totalAmt, totalCnt));

      setDataSumLetter(buildSummary(resLetter.result, totalAmt, totalCnt, "letter"));
      setDataSourceByActionLetter(buildDetail(resLetter.result, totalAmt, totalCnt));

      setDataSumOther(buildSummary(resOther.result, totalAmt, totalCnt, "other"));
      setDataSourceByActionOther(buildDetail(resOther.result, totalAmt, totalCnt));

      setLoading(false);
    }

    fetchData();
  }, []);

  return (
    <>
      <div>
        <div className="card-row">
          {dataSumAll[0] && (
            <SummaryCard title="All" color="#0056B4" icon={imageAll} ac={dataSumAll[0].sumCnt} bal={dataSumAll[0].sumAmt} acPer={100} balPer={100} />
          )}
          {dataSumContact[0] && (
            <SummaryCard
              title="Contact"
              color="#00B42A"
              icon={imageContact}
              ac={dataSumContact[0].sumCount}
              bal={dataSumContact[0].sumCnt}
              acPer={dataSumContact[0].sumCntPer}
              balPer={dataSumContact[0].sumCountPer}
            />
          )}
          {dataSumNoContact[0] && (
            <SummaryCard
              title="No Contact"
              color="#DF3C54"
              icon={imageNocantact}
              ac={dataSumNoContact[0].sumCount}
              bal={dataSumNoContact[0].sumCnt}
              acPer={dataSumNoContact[0].sumCntPer}
              balPer={dataSumNoContact[0].sumCountPer}
            />
          )}
          {dataSumLetter[0] && (
            <SummaryCard
              title="Letter"
              color="#5E8BFF"
              icon={imageLetter}
              ac={dataSumLetter[0].sumCount}
              bal={dataSumLetter[0].sumCnt}
              acPer={dataSumLetter[0].sumCntPer}
              balPer={dataSumLetter[0].sumCountPer}
            />
          )}
          {dataSumOther[0] && (
            <SummaryCard
              title="Other"
              color="#FF7E35"
              icon={imageOther}
              ac={dataSumOther[0].sumCount}
              bal={dataSumOther[0].sumCnt}
              acPer={dataSumOther[0].sumCntPer}
              balPer={dataSumOther[0].sumCountPer}
            />
          )}
        </div>
      </div>

      {/* ===== DETAIL ===== */}
      <div style={{ marginTop: 5 }}>
        <div className="card-row">
          {/* ===== ALL ===== */}
          <div className="detail-col">
            {dataSourceAll.map((all, i) => {
              return (
                <DetailCard
                  key={i}
                  title={all.actionstatus}
                  color="#0056B4"
                  onClick={() =>
                    history.push("/debtmanagement", all.actionstatus === "Action" ? "action" : all.actionstatus === "New" ? "new" : "noAction")
                  }
                  ac={all.cnt}
                  acPer={all.cntPer}
                  bal={all.sumamt}
                  balPer={all.sumamtPer}
                />
              );
            })}
          </div>

          {/* ===== CONTACT ===== */}
          <div className="detail-col">
            {dataSourceByActionContact.map((c, i) => {
              return (
                <DetailCard
                  key={i}
                  title={c.status_name}
                  color="#00B42A"
                  onClick={() =>
                    history.push("/debtmanagement", {
                      actionCode: "contact",
                      statusCode: c.status_code,
                    })
                  }
                  ac={c.count}
                  acPer={c.countPer}
                  bal={c.cnt}
                  balPer={c.cntPer}
                />
              );
            })}
          </div>

          {/* ===== NO CONTACT ===== */}
          <div className="detail-col">
            {dataSourceByActionNoContact.map((c, i) => {
              // console.log(c);

              return (
                <DetailCard
                  key={i}
                  title={c.status_name}
                  color="#DF3C54"
                  onClick={() =>
                    history.push("/debtmanagement", {
                      actionCode: "noContact",
                      statusCode: c.status_code,
                    })
                  }
                  ac={c.count}
                  acPer={c.countPer}
                  bal={c.cnt}
                  balPer={c.cntPer}
                />
              );
            })}
          </div>

          {/* ===== LETTER ===== */}
          <div className="detail-col">
            {dataSourceByActionLetter.map((c, i) => (
              <DetailCard
                key={i}
                title={c.status_name}
                color="#5E8BFF"
                onClick={() =>
                  history.push("/debtmanagement", {
                    actionCode: "letter",
                    statusCode: c.status_code,
                  })
                }
                ac={c.count}
                acPer={c.countPer}
                bal={c.cnt}
                balPer={c.cntPer}
              />
            ))}
          </div>

          {/* ===== OTHER ===== */}
          <div className="detail-col">
            {dataSourceByActionOther.map((c, i) => (
              <DetailCard
                key={i}
                title={c.status_name}
                color="#FF7E35"
                onClick={() =>
                  history.push("/debtmanagement", {
                    actionCode: "other",
                    statusCode: c.status_code,
                  })
                }
                ac={c.count}
                acPer={c.countPer}
                bal={c.cnt}
                balPer={c.cntPer}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
